import * as React from 'react';
const SvgThumbsUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 12v7a.97.97 0 0 0 .6.922q.182.076.38.078H6v-9H4.98a.99.99 0 0 0-.912.62A1 1 0 0 0 4 12m15.281-.96a3.05 3.05 0 0 0-2.32-1.061h-2.635c.04-.181.08-.36.11-.532.515-2.934 0-4-.504-4.594A2.43 2.43 0 0 0 12.075 4a3.08 3.08 0 0 0-2.968 2.751c-.393 1.839-.454 2-.968 2.725l-.768 1.089a2 2 0 0 0-.363 1.14v6.274c.001.532.216 1.04.596 1.416s.896.585 1.433.584h7.247a3.014 3.014 0 0 0 2.997-2.507l.677-4a2.96 2.96 0 0 0-.677-2.432m-1.998 6.1a1.01 1.01 0 0 1-1 .835H9.038v-6.27l.767-1.088a7.6 7.6 0 0 0 1.302-3.509c.036-.543.255-1.209.97-1.108.713.1.574 1.916.362 3.1a20 20 0 0 1-.868 2.882l5.39-.008c.297-.001.58.128.773.352a1 1 0 0 1 .226.813l-.676 4"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgThumbsUp;
